export const getLessonsByUser = async (role, id) => {
  try {
    const response = await fetch(`/api/get-user-lessons/${role}/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};
export const getAllLessons = async (role, id) => {
  try {
    const response = await fetch(`/api/get-lessons`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};
// src/services/lessons.js

export const updateLessonStatus = async (lessonId, status, note) => {
  try {
    const response = await fetch(`/api/lessons/${lessonId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status, note }),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }

    const data = await response.json();
    // console.log("Lesson status updated:", data);
    return data;
  } catch (error) {
    console.error("Error updating lesson status:", error);
  }
};
export const updateLesson = async (lessonId, updatedLesson) => {
  try {
    const response = await fetch(`/api/update-lesson/${lessonId}`, {
      method: "PUT",
      headers: {
        "content-Type": "application/json",
      },
      body: JSON.stringify(updatedLesson),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }
    const data = await response.json();
    // console.log("Lesson updated:", data);
    return data;
  } catch (error) {
    console.error("Error updating lesson:", error);
  }
};
export const deleteLesson = async (lessonId) => {
  try {
    const options = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };
    const res = await fetch(`/api/lessons/${lessonId}`, options);
    const json = await res.json();
    // console.log(json);
    return json;
  } catch (error) {
    console.error(error);
  }
};
